import { PrimeIcons } from "primeng/api"

import { LgkNavMenuItem } from "@logick/ui/api"

export const ADMIN_MENU: LgkNavMenuItem = {
    label: "Admin",
    icon: PrimeIcons.COG,
    routerLink: "admin",
    items: [
        {
            label: "Organisation",
            type: "section",
            items: [
                {
                    label: "Utilisateurs",
                    routerLink: "users",
                    routing: { loadComponent: () => import("@/features/admin/users/users.page").then((it) => it.UsersPage) }
                },
                {
                    label: "Partenaires",
                    routerLink: "partners",
                    routing: {
                        loadComponent: () => import("@/features/admin/partners/partners.page").then((it) => it.default)
                    }
                },
                {
                    label: "Détails de l'organisation",
                    routerLink: "company",
                    featureState: { isLocked: true }
                },
                {
                    label: "Abonnement et factures",
                    routerLink: "price-plan",
                    featureState: { isLocked: true }
                },
            ]
        },
        {
            label: "Canaux de vente",
            type: "section",
            items: [
                {
                    label: "Ventes en ligne",
                    routerLink: "shops",
                    featureState: { isNew: true },
                    routing: {
                        loadComponent: () => import("@/features/admin/shops/shop-details/shop-details").then((it) => it.AdminShopDetails)
                    }
                },
                {
                    label: "Guichets",
                    routerLink: "checkouts",
                    featureState: { isLocked: true }
                },
                {
                    label: "Revendeurs",
                    routerLink: "resellers",
                    featureState: { isLocked: true }
                },
            ]
        },
        /*        {
                    label: "Ressources",
                    type: "section",
                    items: [
                        {
                            label: "Contingents",
                            routerLink: "discounts",
                            featureState: { isLocked: true }
                        },
                        {
                            label: "Ressources",
                            routerLink: "discounts",
                            featureState: { isLocked: true }
                        },
                    ]
                },
        */
        {
            label: "Paramètres",
            type: "section",
            items: [
                {
                    label: "Catégories de partenaires",
                    routerLink: "partner-categories",
                    routing: {
                        loadComponent: () => import("@/features/admin/partner-categories/partner-categories.page").then((it) => it.PartnerCategoriesPage)
                    }
                }, {
                    label: "Contrôle",
                    routerLink: "control-config",
                    routing: {
                        loadComponent: () => import("@/features/admin/control-config/control-config.page").then((it) => it.ControlConfigPage)
                    }
                },
            ]
        }

    ]
}